var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 15
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "doubleTick_svg__a",
    d: "M0 3.614l2.771 4.568L11.989 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "doubleTick_svg__b",
    d: "M2.713 4.679l2.771 4.568 9.218-8.182"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    transform: "translate(2 2.5)"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#FFF",
    strokeWidth: 2.5,
    xlinkHref: "#doubleTick_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#16A361",
    strokeWidth: 1.875,
    xlinkHref: "#doubleTick_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFF",
    strokeWidth: 2.5,
    xlinkHref: "#doubleTick_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#16A361",
    strokeWidth: 1.875,
    xlinkHref: "#doubleTick_svg__b"
  }))));
}
export default SvgDoubleTick;